import { render, staticRenderFns } from "./custom-ag-grid.vue?vue&type=template&id=72bf8147&scoped=true"
import script from "./custom-ag-grid.js?vue&type=script&lang=js&external"
export * from "./custom-ag-grid.js?vue&type=script&lang=js&external"
import style0 from "./custom-ag-grid.css?vue&type=style&index=0&id=72bf8147&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf8147",
  null
  
)

export default component.exports